import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ConferenceRoomList from './components/ConferenceRoomList';
import ConferenceRoomDetail from './components/ConferenceRoomDetail';

function App() {
  return (
    <Router>
      <div className="app">
        <header className="app-header">
          {/*<h1>Conference Room Booking</h1>*/}
        </header>
        <main>
          <Routes>
            <Route path="/" element={<ConferenceRoomList />} />
            <Route path="/room/:id" element={<ConferenceRoomDetail />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App; 